export default __webpack_public_path__ + "static/media/FullScreenIcon.4227178e.svg";